import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React from "react";
import { TaskTypeClassTextAreaSize } from "ui/Scripts/source/models/enums";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import { ITaskTypeFieldPropUpdate } from "../../FormDesignerTypes";

interface IFormDesignerComponentPropertiesTextareaSizeProps {
  taskTypeCol?: ITaskTypeCol;
  onChange?: (values: ITaskTypeFieldPropUpdate[]) => void;
}

export const FormDesignerComponentPropertiesTextareaSize = (
    props: IFormDesignerComponentPropertiesTextareaSizeProps
) => {
    const classes = props.taskTypeCol?.class ?? "";

    const getTextAreaSize = () => {
        const styles = classes
            .split(" ")
            .filter(i => !!i);
        if (!styles.length) return TaskTypeClassTextAreaSize.Small;
        if (styles.find(i => i.equalIgnoreCase(TaskTypeClassTextAreaSize.Small))) return TaskTypeClassTextAreaSize.Small;
        if (styles.find(i => i.equalIgnoreCase(TaskTypeClassTextAreaSize.Medium))) return TaskTypeClassTextAreaSize.Medium;
        if (styles.find(i => i.equalIgnoreCase(TaskTypeClassTextAreaSize.Large))) return TaskTypeClassTextAreaSize.Large;
        if (styles.find(i => i.equalIgnoreCase(TaskTypeClassTextAreaSize.Extra))) return TaskTypeClassTextAreaSize.Extra;
        return TaskTypeClassTextAreaSize.Small;
    };
    
    const handleSelectChange = (event: SelectChangeEvent) => {
        const styles = classes
            .split(" ")
            .filter(i => !!i);
        const newClasses = styles
            .filter(i => ![TaskTypeClassTextAreaSize.Small, TaskTypeClassTextAreaSize.Medium, TaskTypeClassTextAreaSize.Large, TaskTypeClassTextAreaSize.Extra].find(j => i.equalIgnoreCase(j)))
            .concat(`${event.target.value}`)
            .sort()
            .join(" ");
        props.onChange([{
            field: props.taskTypeCol?.field,
            name: "class",
            value: newClasses
        }]);
    };

    const areaSize = getTextAreaSize();

    return (
        <Select name="textAreaSize" value={areaSize} onChange={handleSelectChange}>
            <MenuItem value={TaskTypeClassTextAreaSize.Small}>{Translations.FormSizeSmall}</MenuItem>
            <MenuItem value={TaskTypeClassTextAreaSize.Medium}>{Translations.FormSizeMedium}</MenuItem>
            <MenuItem value={TaskTypeClassTextAreaSize.Large}>{Translations.FormSizeLarge}</MenuItem>
            <MenuItem value={TaskTypeClassTextAreaSize.Extra}>{Translations.FormSizeExtraLarge}</MenuItem>
        </Select>
    );
};
